import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getTerritory = async () => {
  const { data } = await axios.get(`${api_base_url}/Territory/Territory`);
  return data;
};
// Insert New Territory
export const addTerritory = async (newTerritory) => {
  const { data } = await axios.post(`${api_base_url}/Territory/Territory`, {
    ...newTerritory[0],
  });
  return data;
};

// Update Territory
export const updateTerritory = async (updatedTerritory) => {
  const { data } = await axios.put(
    `${api_base_url}/Territory/Territory${updatedTerritory[0].territoryId}`,
    updatedTerritory[0]
  );
  return data;
};
// Deactivate Territory
export const deleteTerritory = async (ids) => {
  await axios.delete(`${api_base_url}/Territory/Territory`, {
    data: ids,
  });
};
